export default __webpack_public_path__ + "static/media/btn_back.fb767366.png";